import styles from './sidebar.module.scss'
import { NavLink } from 'react-router-dom'
import { SidebarComponent } from '@syncfusion/ej2-react-navigations'
import ViewComfyIcon from '@mui/icons-material/ViewComfy'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import { TooltipComponent } from '@syncfusion/ej2-react-popups'
import { isMobile } from 'react-device-detect'

import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks.tsx'

import { triggerAction } from '../../redux/sideBarSlice.tsx'
import { useRef } from 'react'

import useGracefulHover from '../../hooks/useGracefulHover.tsx'
import { Groups2, Person, UploadFile } from '@mui/icons-material'
import useUserRoles from '../../hooks/useUserRoles.tsx'

interface SidebarProps {
  register: boolean
}

export const SideBar = (props: SidebarProps) => {
  const sidebarRef = useRef<SidebarComponent | null>(null)

  const reduxSideBar = useAppSelector((state) => state.sideBar.isToggled)
  const profile = useAppSelector(state => state.register.selectedRegistration)
  const dispatch = useAppDispatch()
  const { hasDocentIdOrInternal, isInternal } = useUserRoles()

  const triggerEnterAction = () => {
    //FixMe: Das aus- und einfahren der Sidebar ist nicht ganz nachvollziehbar, warum es passiert.
    // Muss optimiert werden. Bis dahin nur über das Hamburger Menü zu öffnen.
    dispatch(triggerAction(false))
  }

  const triggerLeaveAction = () => {
    dispatch(triggerAction(false))
  }

  const { handleMouseEnter, handleMouseLeave } = useGracefulHover(
    triggerEnterAction,
    triggerLeaveAction,
    800, // Verzögerung für Enter
    1000, // Verzögerung für Leave
  )

  const trueContent = (
    <SidebarComponent className={`sidebar-menu`} ref={sidebarRef} enableDock={!isMobile} target={'.nw-mainContent'} position="Left" width={'180px'} isOpen={reduxSideBar} dockSize="50px" type={'Push'}>
      <div className={styles.mainMenu}>
        <div className={styles.nav}>
          <TooltipComponent position="RightCenter" content="Registration">
            <NavLink className={styles.navBtn} to="/">
              <ViewComfyIcon />
              <span className={styles.label}>Register</span>
            </NavLink>
          </TooltipComponent>
        </div>
      </div>
    </SidebarComponent>
  )

  const falseContent = (
    <SidebarComponent className={`sidebar-menu`} ref={sidebarRef} enableDock={!isMobile} target={'.nw-mainContent'} position="Left" width={'180px'} isOpen={reduxSideBar} dockSize="50px" type={'Push'}>
      <div className={styles.mainMenu}>
        <div className={styles.nav}>
          {/*<TooltipComponent position="RightCenter" content="Dashboard">*/}
          {/*  <NavLink className={styles.navBtn} to="/">*/}
          {/*    <ViewComfyIcon />*/}
          {/*    <span className={styles.label}>Dashboard</span>*/}
          {/*  </NavLink>*/}
          {/*</TooltipComponent>*/}


          {isInternal && (
            <TooltipComponent position="RightCenter" content="Dozentenübersicht" style={{ marginBottom: '40px' }}>
              <NavLink className={styles.navBtn} to="/instructors">
                <Groups2 />
                <span className={styles.label}>Dozentenübersicht</span>
              </NavLink>
            </TooltipComponent>
          )}

          {/*Folgender Menüpunkt nur sichtbar, wenn der Dozent bereits eine Dozenten ID durch den Mitarbeiter erhalten hat*/}
          {hasDocentIdOrInternal && (
            <>{(profile && profile.adrId !== null) ? (
                <TooltipComponent position="RightCenter" content="Veranstaltungen">
                  <NavLink className={styles.navBtn} to="/seminare">
                    <CalendarMonthIcon />
                    <span className={styles.label}>Veranstaltungen</span>
                  </NavLink>
                </TooltipComponent>) :
              (<div className={`${styles.navBtn} ${styles.disabled}`}>
                <CalendarMonthIcon />
                <span className={styles.label}>Profil</span>
              </div>)}
              {/*Auf eigenes Profil navigieren, wenn Rolle = Docent - ToDo: muss nach Freigabe vom Profil geändert werden */}
              {isInternal && ((profile) ? (
                <TooltipComponent position="RightCenter" content="Profil">
                  <NavLink className={styles.navBtn} to={`/profile`}>
                    <Person />
                    <span className={styles.label}>Profil</span>
                  </NavLink>
                </TooltipComponent>) : (
                <div className={`${styles.navBtn} ${styles.disabled}`}>
                  <Person />
                  <span className={styles.label}>Profil</span>
                </div>
              ))}
              {isInternal && <TooltipComponent position="RightCenter" content="Datei Austausch">
                <NavLink className={styles.navBtn} to="/upload">
                  <UploadFile />
                  <span className={styles.label}>Datei Austausch</span>
                </NavLink>
              </TooltipComponent>
              }
            </>
          )}

          {/* <TooltipComponent position="RightCenter" content="Ausschreibungen">
            <NavLink className={styles.navBtn} to="/ausschreibungen">
              <ListIcon />
              <span className={styles.label}>Ausschreibungen</span>
            </NavLink>
          </TooltipComponent> */}
          {/* <TooltipComponent position="RightCenter" content="Themenvorschlag">
            <NavLink className={styles.navBtn} to="/themenvorschlag">
              <ImportContactsIcon />
              <span className={styles.label}>Themenvorschlag</span>
            </NavLink>
          </TooltipComponent>
          <TooltipComponent position="RightCenter" content="Passwort ändern">
            <NavLink className={styles.navBtn} to="/passwort-aendern">
              <LockOpenIcon />
              <span className={styles.label}>Passwort ändern</span>
            </NavLink>
          </TooltipComponent> */}
        </div>
      </div>
    </SidebarComponent>
  )

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {props.register ? trueContent : falseContent}
    </div>
  )
}
